import { Injectable } from '@angular/core';
import { API, FeUtil, TYPE } from '../../../hezky-routes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private readonly feUtil: FeUtil) { }

  createTicket(formData: any): Observable<any> {
    return this.feUtil.httpSvc.postFile<TYPE.SupportTicket[]>(API.ADMIN.CREATE_TICKET, formData)
  }

  getTickets(): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.ADMIN.GET_TICKETS)
  }

  getDemoVideo(): Observable<any> {
    return this.feUtil.httpSvc.get<any>(API.ADMIN.GET_DEMO_VIDEOS)
  }
}
